import { render, staticRenderFns } from "./CourseCardsAdvanced.vue?vue&type=template&id=736c8f59&"
import script from "./CourseCardsAdvanced.vue?vue&type=script&lang=js&"
export * from "./CourseCardsAdvanced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardsCourseCard: require('/opt/build/repo/components/Cards/CourseCard.vue').default,CardsMoreInfoModal: require('/opt/build/repo/components/Cards/MoreInfoModal.vue').default})
